/*
 * @Author: bill
 * @Date: 2023-03-13 10:05:28
 * @LastEditors: wangzijun@bzstech.com wangzijun@bzstech.com
 * @LastEditTime: 2024-06-11 14:18:46
 * @FilePath: /study/src/index.tsx
 * @Description:
 */
import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import "antd/dist/reset.css";
import "./public-path";
import { setDictItems, setToken } from "./store/modules/base";
import store from "./store";

declare const window: any;
let instance: any = null;

function render(props: any) {
  const { container } = props;
  const root = createRoot(
    container
      ? container.querySelector("#root")
      : document.querySelector("#root")
  );
  root.render(<App />);
  instance = root;
}

if (!window.__POWERED_BY_QIANKUN__) {
  render({});
}

export async function bootstrap() {
  console.log("bootstrap");
}

export async function mount(props: any) {
  store.dispatch(setToken(props.data.token));
  store.dispatch(setDictItems(props.data.dictItemsFromCache));
  render(props);
}

export async function unmount(props: any) {
  console.log("react-app unmount");
  instance.unmount();
  instance = null;
}
